var outputData = {
  name: "output",
  data: [{
    blockColor: "#525A6E"
  }]
};
export default outputData;